import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
`;

export const ContentImage = styled.div`
  width: 65%;         
  height: 100%;
  overflow: hidden;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const Image = styled.img`
    width: 100%;       
    height: 100%;     
    object-fit: cover; // Garante que a imagem cubra todo o contêiner sem distorção

    /* 
        *Animação de fade-in 
    */
    opacity: 0; /* Inicialmente invisível */
    animation: fadeIn 1s ease-in forwards; /* Duração: 1s, com suavização */
    
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

export const ContentForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 35%;

  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 4px 4px 8px 2px rgba(0, 0, 0, 0.4); // x y blur espalhamento
  color: ${(props) => props.theme.colors.black};
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  height: 100%;
  padding: 40px;
  
  position: absolute; 
  right: 0; // Alinha à direita
  z-index: 100; // Garante que fique acima da imagem
  
  @media (max-width: 900px) {
    width: 100%;
    border-radius: 0px;
    padding: 0px;
  }
`;